import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoAlert from '../../components/alert/pendo-alert.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoForm from '../../components/form/pendo-form.vue.js';
import PendoFormItem from '../../components/form/pendo-form-item.vue.js';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoMultiselect from '../../components/multiselect/pendo-multiselect.vue.js';
import invert from 'lodash/invert.js';
import get from 'lodash/get.js';

const MODAL_TYPES = {
  add: 'add',
  edit: 'edit',
  delete: 'delete'
};
var script = {
  components: {
    PendoAlert,
    PendoButton,
    PendoForm,
    PendoFormItem,
    PendoInput,
    PendoModal,
    PendoMultiselect
  },
  props: {
    appId: {
      type: Number,
      required: true
    },
    selectedLanguage: {
      type: Object,
      default: () => {}
    },
    modalType: {
      type: String,
      required: true
    },
    isProcessingChange: {
      type: Boolean,
      default: false
    },
    openModal: {
      type: Boolean,
      required: true
    },
    existingLanguageMappings: {
      type: Object,
      default: () => {}
    },
    languageMapping: {
      type: Object,
      required: true
    },
    serverErrorMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFormValid: false,
      editMetaDataRules: [{
        required: true,
        message: 'This is a required field.',
        trigger: 'blur'
      }, {
        validator: this.validateUniqueMetadataValue,
        trigger: ['change', 'blur']
      }],
      form: {
        language: '',
        metadataValue: ''
      },
      addLanguageAlert: 'Localization for Hebrew / Arabic is currently only supported by the Resource Center. Please Note that translating to these languages will mirror the RC behavior (buttons etc.)'
    };
  },
  computed: {
    enabledLanguageMap() {
      return Object.values(this.languageMap).reduce((map, language) => {
        if (language.metadataValue) {
          map[language.metadataValue] = language.name;
        }
        return map;
      }, {});
    },
    languageMap() {
      const metadataMap = invert(this.existingLanguageMappings);
      return Object.entries(this.languageMapping).reduce((map, _ref) => {
        let [languageCode, {
          name,
          isDeprecated,
          isRTL,
          unsupportedAgent,
          minAgent
        }] = _ref;
        if (!isDeprecated) {
          map[languageCode] = _objectSpread2(_objectSpread2(_objectSpread2({
            name,
            code: languageCode,
            metadataValue: metadataMap[languageCode] || ''
          }, isRTL && {
            isRTL
          }), unsupportedAgent && {
            unsupportedAgent
          }), minAgent && {
            minAgent
          });
        }
        return map;
      }, {});
    },
    languageOptions() {
      return Object.entries(this.languageMap).map(_ref2 => {
        let [languageCode, currentLanguage] = _ref2;
        const {
          name,
          metadataValue,
          isRTL,
          unsupportedAgent = false,
          minAgent
        } = currentLanguage;
        return _objectSpread2(_objectSpread2(_objectSpread2({
          code: languageCode,
          label: `${name} (${languageCode})`,
          disabled: !!metadataValue || unsupportedAgent
        }, isRTL && {
          isRTL
        }), unsupportedAgent && {
          unsupportedAgent
        }), minAgent && {
          minAgent
        });
      });
    },
    modalTitle() {
      switch (this.modalType) {
        case MODAL_TYPES.add:
          return 'Add Language';
        case MODAL_TYPES.edit:
          return 'Edit Language';
        case MODAL_TYPES.delete:
          return `Delete ${this.selectedLanguage.name}?`;
      }
    },
    saveChangesLabel() {
      switch (this.modalType) {
        case MODAL_TYPES.add:
          return 'Add';
        case MODAL_TYPES.edit:
          return 'Save Changes';
        case MODAL_TYPES.delete:
          return 'Delete Language';
      }
    },
    isEditMode() {
      return this.modalType === MODAL_TYPES.edit;
    },
    isAddMode() {
      return this.modalType === MODAL_TYPES.add;
    },
    isDeleteMode() {
      return this.modalType === MODAL_TYPES.delete;
    }
  },
  methods: {
    onModalOpen() {
      if (!this.isEditMode) {
        return;
      }
      this.form.metadataValue = get(this.selectedLanguage, 'metadataValue', '');
    },
    handleClick() {
      if (this.isDeleteMode) {
        this.deleteLanguage();
        return;
      }
      this.updateLanguage();
    },
    updateLanguage() {
      const {
        language,
        metadataValue
      } = this.form;
      const code = this.isEditMode ? this.selectedLanguage.code : language.code;
      this.closeModal();
      this.$emit('update-language', {
        appId: this.appId,
        code,
        metadataValue
      });
    },
    deleteLanguage() {
      this.$emit('delete-language', {
        appId: this.appId,
        langCode: this.selectedLanguage.code
      });
    },
    closeModal() {
      if (!this.isDeleteMode) {
        this.form = {
          language: '',
          metadataValue: ''
        };
      }
      this.$emit('close-language-modal');
    },
    trimMetadataValue(value) {
      this.form.metadataValue = value.trim();
    },
    validateUniqueMetadataValue(rule, value, callback) {
      if (!value) {
        return;
      }
      const existingLanguage = this.enabledLanguageMap[value.trim()];
      if (existingLanguage && value !== this.selectedLanguage.metadataValue) {
        callback(new Error(`Metadata value already in use for ${existingLanguage}`));
      } else {
        callback();
      }
    },
    selectLanguage(newLang) {
      this.form.language = newLang;
      this.form.metadataValue = newLang.code.replace('-', '_');
    }
  }
};

export { MODAL_TYPES, script as default };
//# sourceMappingURL=localization-modal.vue2.js.map
